function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgGymnastics(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M26.781 1.36A1.327 1.327 0 1128.6 3.294L19.17 12.48c-.664 1.102.534 4.182.55 4.224 0 0-.036.546.76.46l6.459-6.252a1.326 1.326 0 111.818 1.932L20.04 21.28l-.053 3.257v6.69c0 .632-.441 1.16-1.033 1.294h14.34l.099.01a.495.495 0 010 .97l-.1.01H1.614a.496.496 0 010-.99h16.753a1.327 1.327 0 01-1.032-1.293v-6.899c-.001-.035-.005-.878-.226-1.504-.196-.557-1.63-.87-2.245-1.837-.614-.969-.103-6.13-.103-6.13l-12.453-.001a1.327 1.327 0 01.037-2.652h12.814c.146.002.285.028.415.073L26.781 1.361zM22.78 20.605a2.222 2.222 0 110 4.442 2.222 2.222 0 010-4.442z",
    fill: props.fill
  }));
}

export default SvgGymnastics;